export enum ApplicantTypeEnum {
    'Personally' = "1",
    'Organization' = 0,
}